if (!customElements.get("shipping-protection")) {
  customElements.define(
    "shipping-protection",
    class ShippingProtection extends HTMLElement {
      constructor() {
        super();
        this.status = this.getAttribute("data-status") || "false";
        this.switch = this.querySelector("[data-swich]");
        this.variantId = this.dataset.id;
        this.switch.addEventListener("click", this.handleSwitch.bind(this));
      }

      handleSwitch() {
        if (this.status == "true") {
          // 删除运费险
          console.log("删除运费险", this.status);
          this.removeShippingProtection();
        } else {
          // 添加运费险
          console.log("添加运费险", this.status);
          this.addShippingProtection();
        }
      }
      removeShippingProtection() {
        const formData = new FormData();
        formData.append(`updates[${this.variantId}]`, 0);

        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
              this.switchOff();
              this.updateCart();
            return response.json();
          })
          .then((data) => console.log(data))
          .catch(err=>{console.error("Error:",err);});
      }
      addShippingProtection() {
        const formData = {
          items: [
            {
              id: this.variantId,
              quantity: 1,
            },
          ],
        };
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((res) => {
            console.log(res);

            this.switchOn();
            this.updateCart();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
      switchOn() {
        this.status = "true";
        this.setAttribute("data-status", this.status);
        this.classList.add("on");
      }
      switchOff() {
        this.status = "false";
        this.setAttribute("data-status", this.status);
        this.classList.remove("on");
      }
      updateCart() {
        document.dispatchEvent(new CustomEvent("theme:cart:reload",{bubbles:!0}));
        // window.fetch(`${window.theme.routes.cart}.js`)
        // .then(response=>response.json())
        // .then(res=>{
        //     console.log("cart res:",res);
           
        // })
        // .catch(err=>{
        //     console.error(err);
        // })
      }
    }
  );
}
